import { useDispatch, useSelector } from 'react-redux';
import setFilter from 'redux/actions/setFilter';
import { get, set } from 'global/lib/lodash';

export const useFilter = (sel) => {
  const dispatch = useDispatch();
  const filter = useSelector((state) => get(state, `filter.${sel}`));

  const changeFilter = (select, value) => {
    const [a, b] = sel.split('.');
    const fi = { ...filter };
    set(fi, select, value);
    dispatch(setFilter(a, b, fi));
  };

  return {
    changeFilter,
    filter,
  };
};
